import axios from '@/plugins/axios';
import { SEARCH_ESTATE_BY_ADDRESS, SEARCH_ESTATE_BY_TRAINLINE } from '@/constants/estate';

const ESTATES = '/estates';
const ESTATE = '/estate';
const ESTATE_LINE = '/estates/lines';
const ESTATE_STATION = '/estates/stations';
const ESTATE_SAVE_CONDITION = '/estates/search-condition';

// for track search
const SAVE_ADDRESS = '/estates/save-result-search-by-address';
const SAVE_TRAIN_LINE = '/estates/save-result-search-by-train-line';

export async function getEstateEdit(id) {
  try {
    const { data } = await axios.get(`${ESTATES}/${id}/edit`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getTotalEstate(params) {
  try {
    const { data } = await axios.get(`${ESTATE}/total-estate`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getEstateProperties() {
  try {
    const { data } = await axios.get(`${ESTATE}/estate-properties`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function updateEstateValidate(id, payload) {
  try {
    const res = await axios.post(`${ESTATES}/${id}/edit/validate`, payload);
    return res;
  } catch (error) {
    return { error };
  }
}

export async function updateEstate(id, payload) {
  try {
    const { data } = await axios.post(`${ESTATES}/${id}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function updateEstateSeller(id, payload) {
  try {
    const { data } = await axios.post(`${ESTATES}/${id}/seller`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function deleteEstate(id, payload) {
  try {
    return await axios.put(`${ESTATES}/bidding/${id}`, payload);
  } catch (error) {
    return { error };
  }
}

export async function getEstateRecommend(params) {
  try {
    const { data } = await axios.get(`${ESTATES}/recommend`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}
export async function getEstateItemValue(id) {
  try {
    const { data } = await axios.get(`${ESTATES}/bidding/${id}/other-setting`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getEstateDetail(id) {
  try {
    const { data } = await axios.get(`${ESTATES}/${id}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getEstateDetailForBidder(id) {
  try {
    const { data } = await axios.get(`${ESTATES}/${id}/bidder`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getEstateSellerDetail(id) {
  try {
    const { data } = await axios.get(`${ESTATES}/${id}/seller`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getEstateSellerExhibitDetail(id) {
  try {
    const { data } = await axios.get(`${ESTATES}/${id}/seller-exhibit`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function createEstate(payload) {
  try {
    const { data } = await axios.post(ESTATES, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getFavorite() {
  try {
    const { data } = await axios.get(`${ESTATES}/estate-favourite`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function likeOrUnlikeEstate(payload) {
  try {
    const data = await axios.post(`${ESTATES}/estate-favourite`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getCompaniesTrainLinePrefecture(prefectureCode) {
  try {
    const data = await axios.get(`${ESTATE_LINE}?prefecture_code=${prefectureCode}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getTrainLineStation(params) {
  try {
    const data = await axios.get(`${ESTATE_STATION}`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getSearchResult(params) {
  try {
    let urlAPI = `${ESTATES}/${SEARCH_ESTATE_BY_ADDRESS}`;
    if (params.from === SEARCH_ESTATE_BY_TRAINLINE) {
      urlAPI = `${ESTATES}/${SEARCH_ESTATE_BY_TRAINLINE}`;
    }
    return await axios.post(urlAPI, { ...params });
  } catch (error) {
    return { error };
  }
}

export async function saveCondition(payload) {
  try {
    const data = await axios.post(ESTATE_SAVE_CONDITION, payload);

    return data;
  } catch (error) {
    return error?.response?.data;
  }
}

export async function biddingEstate(params) {
  try {
    const data = await axios.post(`${ESTATES}/${params.estate_id}/bidding`, {
      max_bidding_price: params.max_bidding_price,
    });

    return data;
  } catch (error) {
    return error?.response?.data;
  }
}

export async function getSearchWatching(params) {
  try {
    const data = await axios.get(`${ESTATES}/search-watch-bidding`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getSearchBidding(params) {
  try {
    const data = await axios.get(`${ESTATES}/search-bidding`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getSearchWonBid(params) {
  try {
    const data = await axios.get(`${ESTATES}/search-won-bid`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getSearchExhibition(params) {
  try {
    const data = await axios.get(`${ESTATES}/search-exhibition`, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function trackUserSearch(params) {
  try {
    let urlAPI = SAVE_ADDRESS;
    if (params.from === SEARCH_ESTATE_BY_TRAINLINE) {
      urlAPI = SAVE_TRAIN_LINE;
    }
    return await axios.post(urlAPI, { ...params });
  } catch (error) {
    return { error };
  }
}

export async function checkBidOneTime(params) {
  try {
    return await axios.post(`/estates/${params.estateId}/check-bid`);
  } catch (error) {
    return error.response.data;
  }
}

export async function checkSamePriceBidding(params) {
  try {
    return await axios.post(`/estates/${params.estateId}/check-same-price`, { max_bidding_price: params.price_input });
  } catch (error) {
    return error.response.data;
  }
}
